export const GA_MEASUREMENT_ID = "G-0V7Z0Y78XT";

/** Send a GA4 page view for client-side route changes. */
export function trackPageView(pagePath: string) {
  if (typeof window.gtag !== "function") return;

  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: pagePath,
  });
}
